export default "__VITE_ASSET__9cl92LIY__"